export type GcCharge = {
  id: number;
  document_id: number;
  amount_cents: number;
  status: string;
  status_label: string;
  open?: boolean;
  paid?: boolean;
  failed?: boolean;
  gc_payment_id?: string | null;
};

export type GcSetup = {
  connected: boolean;
  webhook_url: string;
  webhook_secret_set: boolean;
};

export function asGcCharge(row: GcCharge | null | undefined): GcCharge | null {
  if (!row) return null;
  return {
    id: Number(row.id) || 0,
    document_id: Number(row.document_id) || 0,
    amount_cents: Number(row.amount_cents) || 0,
    status: String(row.status || ""),
    status_label: String(row.status_label || ""),
    open: row.open === true,
    paid: row.paid === true,
    failed: row.failed === true,
    gc_payment_id: row.gc_payment_id ?? null,
  };
}

export type GcMandateRow = {
  mandate_id: string;
  customer_id?: string;
  email: string;
  gc_name?: string;
  gc_address?: string;
  bank_last4?: string;
  client_id?: number;
  client_name?: string;
  candidates?: { id: number; name: string }[];
};

export type GcMandateSync = {
  ready: GcMandateRow[];
  linked: GcMandateRow[];
  doubt: GcMandateRow[];
  orphan: GcMandateRow[];
  clients: { id: number; name: string }[];
  counts: { ready: number; linked: number; doubt: number; orphan: number };
};

export function gcIsOpen(row: { gc_charge?: GcCharge | null } | null | undefined): boolean {
  const c = row?.gc_charge;
  if (!c) return false;
  if (c.open === true) return true;
  return ["pending", "pending_submission", "pending_customer_approval", "submitted", "created"].includes(c.status);
}
